$(document).ready(function(){

  // Change tab class and display content
  $('.tab-nav__link').addClass('inactive');
  $('.tab-pane').hide();
  $('.tab-pane:first').show();

  $('.tab-nav__link').click(function(){
    var t = $(this).attr('data-href');
    $('body').css('overflow', 'hidden');
    $('.modal-fix').addClass('open-modal');
    if($(this).hasClass('inactive')){
      $('.tab-nav__link').addClass('inactive');
      $(this).removeClass('inactive');
      $('.tab-pane').hide();
      $(t).fadeIn('slow');
    }
  });

  // Login Tab
  $('#login .tab-nav__sub-link').addClass('inactive');
  $('#login .tab-sub-pane').hide();
  $('#login .tab-nav__item:first-child .tab-nav__sub-link').removeClass('inactive');
  $('#login .tab-sub-pane:first').show();

  $('#login .tab-nav__sub-link').click(function(){
    var login = $(this).attr('data-href');
    if($(this).hasClass('inactive')){
      $('#login .tab-nav__sub-link').addClass('inactive');
      $(this).removeClass('inactive');

      $('#login .tab-sub-pane').hide();
      $(login).fadeIn('slow');
    }
  });

  // Country Tab
  $('#country .tab-nav__sub-link').addClass('inactive');
  $('#country .tab-sub-pane').hide();
  $('#country .tab-nav__item:first-child .tab-nav__sub-link').removeClass('inactive');
  $('#country .tab-sub-pane:first').show();

  $('#country .tab-nav__sub-link').click(function(){
    var country = $(this).attr('data-href');
    if($(this).hasClass('inactive')){
      $('#country .tab-nav__sub-link').addClass('inactive');
      $(this).removeClass('inactive');

      $('#country .tab-sub-pane').hide();
      $(country).fadeIn('slow');
    }
  });
  $('#country-tab').click(function(){
    $('#africa-india').show();
  });

  // Close Link
  $('.close-btn_link').click(function () {
    $('body').css('overflow', '');
    $('.modal-fix').removeClass('open-modal');
    $('.tab-nav__link').addClass('inactive');
  });

  // Scroll to Top
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 150) {
      $('#return-to-top').fadeIn(200);
    } else {
      $('#return-to-top').fadeOut(200);
    }
  });
  $('#return-to-top').click(function() {
    $('body,html').animate({
      scrollTop : 0
    }, 500);
  });
});
$(document).ready(function(){
  $('li#menuon').on('click',function(){
    $('.close').show();
    $('#close').show();
  });
  $('#close').on('click',function(){
    $('.close').hide();
    $(this).hide();
  });
});